<template>
  <tr :class="{'is-marked': marked}">
    <td>
      <template v-if="policyUpdate">
        <DetailsButton
          title="Dashboard Details"
          entity-type="fulcrumAppDetails"
          :entity="formId"
        >
          <a
            :href="fulcrumAppUrl"
            title="Dashboard"
          >{{ label ? label : 'N/A' }}</a>
        </DetailsButton>
      </template>
      <template v-else>
        <a
          :href="fulcrumAppUrl"
          title="Dashboard"
        >{{ label ? label : 'N/A' }}</a>
      </template>
    </td>

    <td v-if="policyUpdate">
      {{ name }}
    </td>

    <td>
      <template v-if="clientCompany">
        <a
          :href="'/client_companies/' + clientCompany.id"
          :title="clientCompany.name"
        >{{clientCompany.name}}</a>
      </template>
      <template v-else>
        N/A
      </template>
    </td>

    <td class="text-end">
      <span class="label-info">{{ fulcrumAppDashboardType }}</span>
    </td>

    <td class="text-end">
      {{ lastSync ? h$.formatDate.full(lastSync, true) : 'N/A'}}
    </td>

    <td class="table-row-actions">
      <RowAction
        :href="fulcrumAppUrl"
        action="read"
      />

      <RowAction
        v-if="policyUpdate"
        :href="fulcrumAppUrl + '/edit'"
        action="update"
      />
    </td>
  </tr>
</template>

<script>
import Row from "../shared/grid/row";
import RowAction from "../shared/grid/row_action";
import DetailsButton from "../shared/grid/details_button";

import helpers from "../../helpers.js";

export default {
  extends: Row,

  components: {
    RowAction,
    DetailsButton
  },

  props: {
    index: Number,
    id: String,
    formId: String,
    label: String,
    name: String,
    clientCompany: Object,
    lastSync: String,
    dashboardType: String,
  },

  setup () {
    return {
      h$: helpers
    }
  },

  computed: {
    fulcrumAppUrl: function () {
      return "/project_dashboards/" + this.id
    },

    fulcrumAppDashboardType: function () {
      return this.dashboardType ? this.dashboardType.replace(/_/g, ' ') : 'N/A';
    } 
  }
}
</script>
